import { Flow_0_0_2 } from '@flexus/core';

export const BET_85: Flow_0_0_2 = {
	id: '85',
	name: 'prepare_quote',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: 'Wait for SP to load quote'
		}
	},
	startNode: '',
	nodes: {}
};
